import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, Inject, OnDestroy, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { FormControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Apollo } from 'apollo-angular';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { TemplateVariantsService } from '../../services/template-variants/template-variants.service';
import { v4 as uuidv4 } from 'uuid';
import { saveAs } from 'file-saver';

import * as fromGraphQl from './graphql';
import { KeycloakService } from 'keycloak-angular';
import { TemplateVariant, TemplateVariantInput } from '../../entities/template-variant/template-variant';
import { Container } from '../../containers/container';
import { LoadingService } from '../../services/loading.service';
import { File, FileInput } from '../../entities/file/file';
import 'brace';
import 'brace/mode/html';
import 'brace/theme/github';
import { AceComponent } from 'ngx-ace-wrapper';

@Component({
  selector: 'app-template-variant',
  templateUrl: './template-variant.component.html',
  styleUrls: ['./template-variant.component.scss']
})
export class TemplateVariantComponent extends Container<fromGraphQl.TemplateVariantQueryResponse>
implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('editor') editor: AceComponent;

  // general
  public templateVariant: TemplateVariant;
  public id: string;
  public templateKey: string;
  public routeSubscription: Subscription;
  public templateName: string;
  public templateType: string;

  public uploading = false;
  public value = '';
  public isFile = false;
  public fileName = '';

  public variantFormGroup: UntypedFormGroup;
  private env;
  constructor(
    public route: ActivatedRoute,
    public router: Router,
    loadingService: LoadingService,
    apollo: Apollo,
    private fb: UntypedFormBuilder,
    private templateVariantsService: TemplateVariantsService,
    private http: HttpClient,
    protected keycloakAngular: KeycloakService,
    @Inject('env') environment : any
  ) {
    super(apollo, loadingService, fromGraphQl.TEMPLATE_VARIANT_QUERY, environment);
    this.env = environment;
  }

  public counter = 0;
  newID: string;
  public codeValue:any;

  ngAfterViewInit() {
    const aceEditor = this.editor?.directiveRef?.ace();
    aceEditor?.getSession()?.on('change', () => {
      this.onCodeChanged(aceEditor?.getValue());
    });
    aceEditor?.setOptions({
      useWorker: false,
    });
  }


  onCodeChanged(value: any) {
    this.codeValue = value;
    if (this.counter >0) {
      this.variantFormGroup?.markAsDirty();
    }
    this.counter ++;

  }
  ngOnInit(): void {
    const key = 'id';
    this.variantFormGroup = this.fb.group({
      name: [null, [Validators.required]],
      // plainText: [null],
      // subject: [null],
      isActive: [null]
    });
    // if we call this compobent with an ID, we want do load a model
    this.routeSubscription = this.route.params
      .pipe(
        filter((params) => params[key] !== undefined)
      )
      .subscribe((params) => {
        if (params[key] && params[key] !== 'create') {
          this.id = params[key];
        }
        if (params['templateKey']) {
          this.templateKey = params['templateKey'];
        }
        this.subscribeToQuery({
          id: this.id,
          templateKey: this.templateKey
        });
      });
  }

  ngOnDestroy(): void {
    this.routeSubscription?.unsubscribe();
    super.ngOnDestroy();
  }

  handleSubscriptionResult(data: fromGraphQl.TemplateVariantQueryResponse): void {
    this.loadingService.setLoading(false);
    if (data) {
      this.queryRef.stopPolling();
      if (data.templateName) {
        this.templateName = data?.templateName;
      }
      this.templateType = data?.templateType;
      if (this.templateType === 'EMAIL') {
        this.variantFormGroup?.addControl('subject', new FormControl([null]));
        this.variantFormGroup?.addControl('plainText', new FormControl([null]));
        this.variantFormGroup?.updateValueAndValidity();
      }
      if (data.templateVariant) {
        this.templateVariant = new TemplateVariant(data.templateVariant);
        // console.log(this.templateVariant);
        this.variantFormGroup.patchValue(this.templateVariant);
        if (data.templateVariant?.htmlCode) {
          let code = data.templateVariant?.htmlCode;
          this.codeValue = decodeURIComponent(escape(atob(code)));
        }
        if (this.templateVariant?.attachments && this.templateVariant?.attachments?.length > 0 ) {
          this.isFile = true;
          // console.log(this.isFile);
          this.fileName = data?.templateVariant?.attachments? data?.templateVariant?.attachments[0]?.fileName: '';
        }
      }
    }
  }

  saveTemplateVariant(): void {
    this.loadingService.setLoading(true);
    const formModel = this.variantFormGroup.value;
    // console.log('to save form', formModel);
    const userModel = new TemplateVariantInput();
    userModel.templateKey = this.templateKey;
    userModel.externalId = null;
    userModel.name = formModel.name;
    if (this.templateType === 'EMAIL') {
      userModel.plainText = formModel?.plainText;
      userModel.subject = formModel?.subject;
    }
    userModel.isActive = formModel?.isActive? formModel.isActive : false;

    if (this?.codeValue) {
      userModel.htmlCode = btoa(unescape(encodeURIComponent(this.codeValue)));
    } else {
      userModel.htmlCode = '';
    }
    userModel.attachments = this.templateVariant?.attachments? this.getFileInput(this.templateVariant.attachments):[];
    if (this.value) {
      userModel.attachments[0] = new FileInput({id: this.value, key: this.value +'.pdf'});
    }
    console.log('model to save', userModel)
    if (this.id) {
      userModel.id = this.id;
      userModel.externalId = this.templateVariant?.externalId;
      this.templateVariantsService.updateTemplateVariant(
        userModel,
        this.returnCallback(this.router)
      );
    } else {
      this.templateVariantsService.createTemplateVariant(
        userModel,
        this.returnCallback(this.router)
      );
    }
  }

  returnCallback(router: Router): void {
    setTimeout(() => {
      this.loadingService.setLoading(false);
      router.navigate(['/settings/templates/']);
    }, 500);
  }

  abort(): void {
    this.router.navigate(['/settings/templates/']);
  }

  fileChangeEvent(event: any): void {
    if (this.uploading || event.target?.files?.length < 1) {
      return;
    }
    const uuid = uuidv4();
    // if (!this.id && !this.newID) {
    //   this.newID = uuidv4();
    // }
    this.value = uuid;
    this.uploading = true;
    const params = new HttpParams({
      fromObject: {
        fileName:  event.target?.files[0].name
      }
    });
    let ownerId = this.id? this.id : null;
    console.log('value to upload', this.value);
    console.log('fielApi', this.env.fileApi);
    const url = this.env.fileApi + '/file/upload/?ownerId='+ ownerId;
    const formData: FormData = new FormData();
    formData.append('file', event.target?.files[0], this.value + '.pdf');
    this.http
      .post(url, formData, {params})
      .toPromise()
      .then((data) => {
        console.log('Upload Success', data);
        this.returnUpload();
        this.variantFormGroup?.markAsDirty();
        this.isFile = true;
        let key = 'tenant_id';
        let tenantName = this.keycloakAngular.getKeycloakInstance()
          ? (this.keycloakAngular.getKeycloakInstance()?.idTokenParsed as any)[key]
          : '';
        this.fileName = tenantName + '/'+ this.value + ".pdf";
      })
      .catch((error) => {
        console.log('Upload Error', error);
        this.returnUpload();
      });
  }
  returnUpload(): void {
    setTimeout(() => {
      this.uploading = false;
    }, 1000);
  }

  public downloadPDF(): void {

    const downloadName = this.fileName?.split('/')[1];
    const url = this.env.fileApi + '/file/'+ this.fileName;
    this.http.get(url, { responseType: 'blob' }).subscribe((response: any) => {
      const blob = new Blob([response], { type: 'application/pdf' });
      saveAs(blob, downloadName);
    });
  }
  getFileInput(files: File[]) : FileInput[] {
    let fileInputs = [];
    for (let val of files) {
      fileInputs.push(new FileInput({'id': val?.id}));
    }
    return fileInputs;
  }

  deletePDF() {
    this.templateVariant.attachments = [];
    this.isFile = false;
    this.variantFormGroup.markAsDirty();
  }

  getCode(code: any): any {
    return decodeURIComponent(escape(atob(code)));
  }
}
